import { Routes, UrlSegment } from '@angular/router';

function queryMatcher(path: string, matching: boolean, queryKey: string, queryValue: string = null) {
  return (url: UrlSegment[]) => {
    const fullPath = url.map(segment => segment.path).join('/');
    const queryParams = new URLSearchParams(window.location.search);
    if (fullPath === path) {
      if (matching && queryParams.get(queryKey) === queryValue) {
        return {consumed: url};
      }
      if (!matching && !queryParams.has(queryKey)) {
        return {consumed: url};
      }
    }
    return null;
  };
}


export const ROOT_PAGES_ROUTES: Routes = [
  {
    path: 'Authorization-request.aspx',
    loadComponent: () =>
      import('@root/Pages/authorization-request/authorization-request.component').then(c => c.AuthorizationRequestComponent),
    pathMatch: 'full',
  },
  // {
  //   path: 'Cookies.aspx',
  //   loadComponent: () => import('@root/Pages/cookies/cookies.component').then((c) => c.CookiesComponent),
  //   pathMatch: 'full',
  // },
  {
    path: 'CookiePolicy.aspx',
    loadComponent: () => import('@root/Pages/cookie-policy/cookie-policy.component').then(c => c.CookiePolicyComponent),
    pathMatch: 'full',
  },
  {
    path: 'PrivacyPolicy.aspx',
    loadComponent: () => import('@root/Pages/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent),
    pathMatch: 'full',
  },
  {
    path: 'FrontPage.aspx',
    loadComponent: () => import('@root/Pages/front-page/front-page.component').then(c => c.FrontPageComponent),
    pathMatch: 'full',
  },
  {
    path: 'FrontPageIFramed.aspx',
    loadComponent: () => import('@root/Pages/front-page-iframed/front-page-iframed.component').then(c => c.FrontPageIFramedComponent),
    pathMatch: 'full',
  },
  {
    path: 'Login.aspx',
    loadComponent: () => import('@root/Pages/login/login.component').then(c => c.LoginComponent),
    pathMatch: 'full',
  },
  {
    path: 'Reset-Password.aspx',
    loadComponent: () => import('@root/Pages/reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
    pathMatch: 'full',
  },
  {
    matcher: queryMatcher('ForgotPassword.aspx', true, 'Context', 'EnablingUSR', ),
    loadComponent: () => import('@root/Pages/first-login/first-login.component').then(c => c.FirstLoginComponent),
    pathMatch: 'full',
  },
  {
    matcher: queryMatcher('ForgotPassword.aspx', true, 'Context', 'EnablingADV',),
    loadComponent: () => import('@root/Pages/first-login/first-login.component').then(c => c.FirstLoginComponent),
    pathMatch: 'full',
  },
  {
    matcher: queryMatcher('ForgotPassword.aspx', true, 'Context', 'ForgotPWD'),
    loadComponent: () => import('@root/Pages/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
    pathMatch: 'full',
  },
  {
    path: 'FirstLogin.aspx',
    loadComponent: () => import('@root/Pages/first-login/first-login.component').then(c => c.FirstLoginComponent),
    pathMatch: 'full',
  },
];
